export const leaderboardStats = [
  'champion',
  'runner_up',
  'third',
  'podium',
  'points',
  'hunter',
] as const
export type LeaderboardStat = (typeof leaderboardStats)[number]

export const leaderboardStatLabels = {
  champion: '冠军',
  runner_up: '亚军',
  third: '季军',
  podium: '入围',
  points: '积分',
  hunter: '猎人',
} satisfies Record<LeaderboardStat, string>

export interface LeaderboardStatCounts {
  goldCount: number
  silverCount: number
  bronzeCount: number
  points: number
  bountyCount: number
}

export function leaderboardStatValue(
  stat: LeaderboardStat,
  counts: LeaderboardStatCounts,
): number {
  if (stat === 'champion') return counts.goldCount
  if (stat === 'runner_up') return counts.silverCount
  if (stat === 'third') return counts.bronzeCount
  if (stat === 'podium')
    return counts.goldCount + counts.silverCount + counts.bronzeCount
  if (stat === 'hunter') return counts.bountyCount
  return counts.points
}

export function leaderboardStatValueText(
  stat: LeaderboardStat,
  value: number,
): string {
  return stat === 'points' ? value.toLocaleString('zh-CN') : String(value)
}
